
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';
import { SelectOption } from './types';

@Component({ components: { ValidationProvider } })
export default class RadioButtonGroup extends Vue {
  @Prop({ required: true }) value!: SelectOption;
  @Prop({ required: true }) options!: SelectOption[];
  @Prop() classes!: string;
  @Prop() disabled!: boolean;
  @Prop() rules!: [Object, String];

  innerValue: SelectOption | null = null;

  mounted() {
    this.onOutValueChange(this.value);
  }

  @Watch('innerValue')
  onValueChange(value: any) {
    this.$emit('input', value || null);
  }

  @Watch('value')
  onOutValueChange(option: SelectOption) {
    if (!option) return (this.innerValue = option);
    const index = this.options.findIndex(o => o.value === option.value);
    this.innerValue = index >= 0 ? this.options[index] : null;
  }
}
